<template>
  <div>
    <Table class="table"  @on-selection-change="showSelect" border :data="bigBoardData" :columns="bigBoardColumns" highlight-row stripe >
    </Table>
  </div>
</template>

<script>
  import {getChildDelete}  from "@/api/index";
  export default {
    name: "bigBoardExpandRowNew",
    props:{
      bigBoardData:{
        type:Array,
        default:[],
        
      },
      sendType:{
        type:Number,
        default:0,
        
      },
      
    },
    data(){
      return {
        selectedPapers:[],
        bigBoardColumns:[
          // {
          //   type: 'selection',
          //   width: 60,
          //   align: 'center',
          //  key:'selection'
          // },

          {
            title: "序号",
            type: "index",
            width: 70,
            align: "center"
          },
          {
              title: "物料编号",
              align: "center",
              key: "code",
               width: 300,
              tooltip: true,
          },
          {
            title: "数量",
            align: "center",
            key: "fulfillOrderNum",
            width: 220,

          },
          {
              title: "单位",
              align: "center",
              key: "unit",
              width: 150,

          },
          {
              title: "规格",
              align: "center",
              key: "size",
              width: 190,

          },
         
          {
            title: "操作时间",
            align: "center",
            key: "operateTime",
            sortable:'true',
            width: 300,

          },
         
          {
            title: "操作人",
            align: "center",
            key: "operator",
            sortable:'true',
            width: 220,

          },
          {
        title: "操作",
        key: "action",
        align: "center",
        width: 130,
        render: (h, params) => {
          return h("div", [
            h(
             "button", {
                style: {
                  marginRight: "10px",
                  display: "inline",
                  cursor: 'pointer',
                  padding: "2px 4px",
                  background: "FFFFFF",
                  border: "none",
                },
              on: {
                click: () => { //编辑

                  this.$Modal.confirm({
                    title: "删除",
                    content: "是否确认删除?",
                    onOk: () => {
                      getChildDelete({
                        id: params.row.id
                      })
                        .then(res => {
                          if (res.code == 200) {
                            this.$Message.success('删除成功！');
                            // let bigBoardDatas = JSON.parse(JSON.stringify(this.bigBoardData))
                            // let arr = []
                            // bigBoardDatas.map( item => {
                            //   if(item.id != params.row.id){
                            //     arr.push(item)
                            //   }
                            // })
                            this.bigBoardData = this.bigBoardData.filter(obj => obj.id !== params.row.id)

                            // console.log("bigBoardDatas",bigBoardDatas,arr);
                          }
                        })
                    }
                  });

                }
              }
            },
              "删除"
            ),
          ]);
        }
      }

        ],
      }
    },
    methods:{
      getBigBoardData(data){
        // this.bigBoardData = data
        console.log("123");
      },
      showSelect(v){
        this.selectedPapers = v;
        this.$emit('setSendPaper',v)
      },
      init(){


      }
    },
    created(){
      

    
      // this.init()
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/bigBoardExpandRowNew.vue